export default {
  message_center: 'Message Center',
  message_admin: 'Message Reception Management',
  message_clear_unread: 'Clear Unread',
  message_all: 'All',
  message_unread: 'Unread {0}',
  message_fault_notification: 'Fault Notification',
  message_work_order_message: 'Work Order Message',
  message_system_notification: 'System Notification',
  message_untreated: 'Untreated',
  message_processed: 'Processed',
  message_recovered: 'Recovered',
  message_unrecovered: 'Unrecovered',

  message_processed_all: 'Process All',
  message_reset_default: 'Reset to Default',
  message_reception_management: 'Message Reception Management',

  message_table_message_type: 'Message Type',
  message_table_internal_message: 'Internal Message',
  message_table_email: 'Email',
  message_table_email_receiving_frequency: 'Email Notification Frequency',
  message_table_email_receiving_frequency1:
    'Instant Notification: A new notification email will be sent for every new message.',
  message_table_email_receiving_frequency2:
    'Delayed Notification: A notification email will be sent only once within a set period. For example, if set to delay for 24 hours, only one notification email will be sent within 24 hours.',
  message_table_email_receiving_frequency3:
    'It is recommended to select delayed notifications with a reasonable interval to avoid excessive emails. If immediate notifications are required, please contact the MBE administrator.',
  message_table_normal_warning: 'Normal Warning Notification for Device',
  message_table_important_warning: 'Important Warning Notification for Device',
  message_table_serious_warning: 'Serious Warning Notification for Device',
  message_table_order_message: 'Work Order Message',
  message_table_immediately_frequency: 'Immediate',
  message_table_repeat_delay: 'Delayed',
  message_table_repeat_delay_placeholder: 'Select Delay Time',
  message_table_description_title: 'Description',
  message_table_description_content:
    'You can set the reception method for each type of message. It is recommended to receive all messages as internal messages to prevent missing important notifications. For email reception, choose to avoid excessive emails and receive important ones as soon as possible.',

  message_confirm_notice_title: 'Notice',
  message_confirm_clear_unread_content: 'Are you sure you want to clear unread messages?',
  message_confirm_handle_one_content: 'Are you sure you want to process this notification?',
  message_confirm_handle_all_content: 'Are you sure you want to process all notifications?',
  message_confirm_reset_content: 'Are you sure you want to reset to default?',

  message_search: 'Search',
  message_search_tips1: 'Total',
  message_search_tips2: 'search results',
  message_search_unit: 'records',
  message_search_result_detail_links: 'Go to details >',
  message_confirm_clear_unread_title: 'Notice',
  message_handle_loading: 'Processing...',
  message_url_redirect: 'Redirect to',
};
